import { AdvancedAnalyticsEntityType } from 'components/modal/modalList/graphDetails/components/AdvancedAnalyticsEntityTypes/AdvancedAnalyticsEntityTypes';

/**
 * for Advanced Analytics
 */

export const RENAME_PARAM_MAPPING = {
  [AdvancedAnalyticsEntityType.operations]: {
    projectId: 'projects',
  },
  [AdvancedAnalyticsEntityType.payments]: {
    projectId: 'projects',
  },
  [AdvancedAnalyticsEntityType.payments_sa]: {
    projectId: 'projects',
  },
  [AdvancedAnalyticsEntityType.inout]: {
    projectId: 'projects',
    columns: 'groupByColumns',
    rows: 'groupByRows',
    issuerCountry: 'country',
  },
  [AdvancedAnalyticsEntityType.inout_sales_agents]: {
    projectId: 'projects',
    columns: 'groupByColumns',
    rows: 'groupByRows',
  },
  [AdvancedAnalyticsEntityType.declineReasons]: {
    columns: 'groupByColumns',
    rows: 'groupByRows',
    issuerCountry: 'countryByBin',
    country: 'countryByIp',
  },
  [AdvancedAnalyticsEntityType.topten]: {},
  [AdvancedAnalyticsEntityType.declineCodes]: {},
  [AdvancedAnalyticsEntityType.fraud_report]: {},
  [AdvancedAnalyticsEntityType.chargeback]: {},
};

export const FILTERS_RENAME_PARAM_MAPPING = {
  [AdvancedAnalyticsEntityType.operations]: {
    projects: 'projectId',
  },
  [AdvancedAnalyticsEntityType.payments]: {
    projects: 'projectId',
  },
  [AdvancedAnalyticsEntityType.payments_sa]: {
    projects: 'projectId',
  },
  [AdvancedAnalyticsEntityType.inout]: {
    projects: 'projectId',
    groupByColumns: 'columns',
    groupByRows: 'rows',
    country: 'issuerCountry',
  },
  [AdvancedAnalyticsEntityType.inout_sales_agents]: {
    projects: 'projectId',
    groupByColumns: 'columns',
    groupByRows: 'rows',
  },
  [AdvancedAnalyticsEntityType.declineReasons]: {
    groupByColumns: 'columns',
    groupByRows: 'rows',
    countryByBin: 'issuerCountry',
    countryByIp: 'country',
  },
  [AdvancedAnalyticsEntityType.topten]: {},
  [AdvancedAnalyticsEntityType.declineCodes]: {},
  [AdvancedAnalyticsEntityType.fraud_report]: {},
  [AdvancedAnalyticsEntityType.chargeback]: {},
};
